import React from 'react';
import { Paragraph } from '../integration-strategies/modal-strategy/modal-strategy.styles';

import {
    TEST_ID,
    SLOT_TITLE,
    MODAL_TITLE,
    MODAL_SUBTITLE_INITIAL,
    MODAL_SUBTITLE_FINAL,
    API_TOKEN_LINK,
    APPCUES_ID,
} from './woocommerce.constants';
import { Woocommerce } from './woocommerce-modal-container';
import { features } from '../../feature-toggle/feature-toggle.constants';
import { createFeatureToggleModalIntegration } from '../integration-strategies';
import { ICON_SIZE, TEXTS } from '../integrations.constants';
import Images from '../../../shared/constants/ImageConstants';

const Subtitle = () => (
    <Paragraph>
        { MODAL_SUBTITLE_INITIAL }
        <a href={API_TOKEN_LINK} target="_blank" rel="noopener noreferrer">{ MODAL_SUBTITLE_FINAL }</a>
    </Paragraph>
);

export const woocommerceIntegration = createFeatureToggleModalIntegration({
    id: 'woocommerce',
    title: SLOT_TITLE,
    icon: <img
        height={ICON_SIZE}
        width={ICON_SIZE}
        src={Images.SOCIAL_MEDIA_LOGOS.WOOCOMMERCE}
        alt="woocommerce"
    />,
    testId: TEST_ID,
    feature: features.reportIntegration,
    modal: {
        title: MODAL_TITLE,
        subtitleComponent: Subtitle,
        body: Woocommerce,
    },
    dataAppcuesId: APPCUES_ID,
    subtitle: TEXTS.MAINTENANCE,
});
